import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BaseSimpleDialogComponent } from '../base-simple-dialog/base-simple-dialog.component';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-student-department',
  templateUrl: './student-department.component.html',
  styleUrls: ['./student-department.component.css']
})
export class StudentDepartmentComponent extends BaseSimpleDialogComponent implements OnInit {

  currentDepartmentId: string = '';
  currentDepartmentName: string = '';
  postedLessonCount: number = 0;
  backDeptThreshold: number = 13;
  qualifiesForBackDept: boolean = false;
  isLoading: boolean = true;

  ngOnInit(): void {
    this.loadCurrentDepartment();
  }

  loadCurrentDepartment(): void {
    this.isLoading = true;
    const studentAccountId = this._injectedDialogData?.['data']?.['student_account_id'];
    const studioReference = this._authService.studios?.[0]?.id;

    if (!studentAccountId || !studioReference) {
      LoggerService.error('Missing student_account_id or studio_reference');
      this.isLoading = false;
      return;
    }

    this._drupalRESTService.httpGET(`/api/v1/student-department/${studentAccountId}`, [
      { parameter: 'field_studio_reference', value: studioReference }
    ]).subscribe(
      (data: any) => {
        this.isLoading = false;
        if (data) {
          this.currentDepartmentId = data.department_id || '';
          this.currentDepartmentName = data.department_name || 'Not Set';
          this.postedLessonCount = data.posted_lesson_count || 0;
          this.backDeptThreshold = data.back_dept_threshold || 13;
          this.qualifiesForBackDept = data.qualifies_for_back_dept || false;
        }
      },
      error => {
        this.isLoading = false;
        LoggerService.error('Error loading department info:', error);
      }
    );
  }

  override onSubmit(form: NgForm) {
    this.displayProgressSpinner(true);

    const values = form.value;
    const studentAccountId = this._injectedDialogData?.['data']?.['student_account_id'];
    const studioReference = this._authService.studios?.[0]?.id;

    if (!studentAccountId || !studioReference) {
      this.errorMessage = 'Missing required data';
      this.displayProgressSpinner(false);
      return;
    }

    const payload = {
      student_account_id: studentAccountId,
      department_id: values['student-department'],
      field_studio_reference: studioReference
    };

    this._drupalRESTService.httpPOST('/api/v1/student-department/override', payload)
      .subscribe(
        (data: any) => {
          this.displayProgressSpinner(false);
          if (data.success) {
            this.closeDialog({ updated: true });
          } else {
            this.errorMessage = data.error || 'Failed to update department';
          }
        },
        error => {
          this.displayProgressSpinner(false);
          this.errorMessage = error?.error?.error || 'There was a problem updating the department.';
        }
      );
  }

}
